export default __webpack_public_path__ + "static/media/watchwadd.bfee1081.jpg";